import { useMemo } from 'react';
import { groupWordsBySpeaker } from './utils';
import { ClipPreviewTranscriptProps } from './types';
import { useCaptionGeneration } from './hooks/useCaptionGeneration';
import { TranscriptEmptyState } from './components/TranscriptEmptyState';
import { TranscriptMonologueList } from './components/TranscriptMonologueList';
import { TRANSCRIPT_MESSAGES } from './constants';
import Loader from '@/components/atoms/Loader';

export default function ClipPreviewTranscript({ clip, onCaptionsGenerated }: ClipPreviewTranscriptProps) {
  const { captions, speakers, isGenerating, isLoadingSpeakers, error } = useCaptionGeneration({
    clip,
    onCaptionsGenerated
  });

  const speakerMonologues = useMemo(() => {
    if (!captions || captions.length === 0) {
      return [];
    }
    return groupWordsBySpeaker(captions);
  }, [captions]);

  if (isGenerating || isLoadingSpeakers) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader size="medium" />
      </div>
    );
  }

  if (error) {
    return <TranscriptEmptyState message={error} />;
  }

  if (!captions || captions.length === 0) {
    return <TranscriptEmptyState message={TRANSCRIPT_MESSAGES.NO_TRANSCRIPT} />;
  }

  if (speakerMonologues.length === 0) {
    return <TranscriptEmptyState message={TRANSCRIPT_MESSAGES.UNABLE_TO_PROCESS} />;
  }

  return <TranscriptMonologueList monologues={speakerMonologues} speakers={speakers} />;
}
